import React, { useEffect, useState } from 'react';
import bearerimg from '../images/bearerimg.jpg';
import { IoArrowUpCircleOutline } from "react-icons/io5";
import { useEventCallback } from '@mui/material';
import { Player, Controls } from '@lottiefiles/react-lottie-player';

export default function OfficeBearer() {

  const lottiee = require('../images/lottiee.json');
  const loading = require('../images/loading.json');

  const [bearerData, setbearerData] = useState([]);
  const [loader, setloader] = useState(false)

    const officeBearer = ()=>{
     setloader(true)
      const requestOptions = {
        method: "GET",
        redirect: "follow"
      };
      
      fetch("https://api.padampura.com/Committee_OfficeList", requestOptions)
       .then((response) => response.json())
        .then((result) => {
          if(result.status === true){
            setbearerData(result.data.OfficeBearers)
            setloader(false)
          }else{
            setloader(false)
          }
        })
        .catch((error) => console.error(error))
        .finally(()=> setloader(false))
    }

    const scrollToTop = () => {
        window.scrollTo({
          top: 0,
          behavior: "smooth" 
        });
      };

      useEffect(()=>{
        scrollToTop();
        officeBearer();
      },[])

  return (
    <div className='mt-5 p-5'>
        <div className='container'>
          <div className='text-center' style={{ color: "#DC7633", fontFamily: "Poppins", fontWeight: 500, fontSize: 20 }}>Committe</div>
          <div className='text-center' style={{ color: "#000", fontFamily: "Poppins", fontWeight: 500, fontSize: 24 }}>OFFICE BEARER'S</div>
          <div className='row mt-5'>
           {
            loader?(
              <>
                <div className='text-center' style={{ fontFamily:"Poppins", fontSize:16 }} >Loading...</div>
                     <Player
                         autoplay
                         loop
                         src={loading}
                         style={{ height: '200px', width: '200px' }}
                     >
                     <Controls visible={false} buttons={[ 'play', 'repeat', ]} />
                 </Player>
              </>
            ):bearerData?.length == 0?(
              <>
                 <Player
                       autoplay
                       loop
                       src={lottiee}
                       style={{ height: '180px', width: '180px' }}
                   >
                   <Controls visible={false} buttons={['play', 'repeat', ]} />
               </Player>
              <div className='text-center' style={{ fontFamily:"Poppins", fontSize:16, color:'red' }} >Data Not Present...</div>
              </>
            ):(
              bearerData?.map((item, index)=>{
                return(
                 <div className='col-lg-3 col-md-6 col-sm-12 mb-3'>
                    <div key={index} className='card border-0'>
                        <img src={item.img} style={{width:"100%"}} />
                        <div className='text-center' style={{ fontFamily:'Poppins', fontWeight:600, color:"#808B96" }} >{item.OfficeBearer_Name}</div>
                        <div className='text-center' style={{ fontFamily:'Poppins', fontWeight:500, color:"#808B96" }} >{item.OfficeBearer_Designation}</div>
                    </div>
                 </div>
                )
              })
            )
           }
          </div>
        </div>
        <button className="scroll-to-top-button border-0 rounded-2" onClick={scrollToTop} style={{ width:40,height:40, backgroundColor:"red", color:"#fff", alignItems:"center", justifyContent:"center", display:"flex" }}><IoArrowUpCircleOutline style={{ fontSize:40 }} /></button>
    </div>
  )
}
